import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { Creators } from "./model"

export default createModule({
  view,
  mapStateToProps: state => ({
    ...state.modules.dialog,
    superModalOpened: get(state, "user.sessionExpired"),
  }),
  actions: Creators,
})
